<template>
	<div v-loading="pageLoading">
		<h1>問卷設置</h1>
		<div id="content">
			<ol>
				<li v-for="item in list" :key="item.id">
					<p>{{ item.content }} <small v-show="item.allNumScore" :class="item.allNumScore>80?'red':'gray'" >（錯誤率 {{item.allNumScore}}%）</small> </p>
					<ol>
						<li type="A">
							{{ item.optionA }}
						</li>
						<li type="A">
							{{ item.optionB }}
						</li>
						<li type="A">
							{{ item.optionC }}
						</li>
						
						<li type="A">
							{{ item.optionD }}
						</li>
					</ol>
					<p>單題：{{item.score}}分</p>
				</li>
			</ol>
			<div>
				<p>合計：{{ score }}分</p>
				<p>合格線：{{ acceptance }}分</p>
			</div>
		</div>
		<el-button class="btn" @click="$router.back(-1)">返 回</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			pageLoading: false,

			list: [],
			acceptance: '',
			score:''
		};
	},
	mounted() {
		$('#pageHead').text('试卷');
	},
	created() {
		// var sectionMsg = JSON.parse(sessionStorage.getItem("sectionMsg"))
		var testingId = sessionStorage.getItem('testingId');
		// this.acceptance = sectionMsg.testingQualified;
		var type = sessionStorage.getItem("courseType");
		if (type == 'online') {
			this.pageLoading = true
			this.axios({
				url:"/manage/getManOnlineCheckPaper",
				params:{
					id:testingId
				}
			}).then(res=>{
				this.list = res.result.ytopice;
				this.acceptance = res.result.acceptance.qualified;
				let score = 0
				res.result.ytopice.forEach(elem => {
					score += elem.score 
				});
				this.score = score
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		} else if(type=="offline"){
			this.pageLoading = true
			this.axios({
				url:"/manage/getManOfflineCheckPaper",
				params:{
					id:testingId
				}
			}).then(res=>{
				this.list=res.result.ytopice;
				this.acceptance = res.result.acceptance.qualified;
				let score = 0
				res.result.ytopice.forEach(elem => {
					score += elem.score 
				});
				this.score = score
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		} else if(type=="live"){
			this.pageLoading = true
			this.axios({
				url:"/manage/getManLiveCheckPaper",
				params:{
					id:testingId
				}
			}).then(res=>{
				this.list=res.result.ytopice;
				this.acceptance = res.result.acceptance.qualified;
				let score = 0
				res.result.ytopice.forEach(elem => {
					score += elem.score 
				});
				this.score = score
				this.pageLoading = false
			}).catch(() => {
				this.pageLoading = false
			})
		}
		
		
	}
};
</script>

<style scoped>

#content {
	padding: 20px;
	border: #000000 1px solid;
	border-radius: 5px;
}
.btn {
	position: absolute;
	top: 90px;
	right: 45px;
}
.red{
	color: red;
}
.gray{
	color: gray;
}
</style>
